import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AuthHandlerInstance from '../Classes/AuthHandler'
import SearchBar from '../Components/SearchBar';
import Loading from '../Components/Loader';
import { GetPOAndPOLineItemSummary, PurchaseOrderAllocationDetails, GetPurchaseOrderAllocation } from '../store/actions/poDetailsActions'
import { GetFilterList } from '../store/actions/masterActions'
import Select, { components } from "react-select"
import DropdownFlat from '../Components/DropdownFlat'
import TableComp from '../Components/ReusableTable'
import toast from 'react-hot-toast';
import authInstance from '../Classes/AuthHandler';


class PurchaseOrderAllocation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: "",
            tableData: [],
            TPMList: [],
            CPMList: [],
            sortByEmployees: [],
            tableData: [],
            tableData1: [],
            projectNo: "",
            SelectedTPM: [],
            SelectedCPM: [],
            searchFor: '',
            searchForItem:[],
            searchForOptions: [
                { label: 'Project No.', value: 'WBS' },
                { label: 'Employee Name', value: 'Employee Name' },
                { label: 'Created By', value: 'Created By' },
            ],
        }
    }
    componentDidMount() {
        this.DataSync()
        this.getFilterList()
    }
    DataSync = async () => {
        var UserId = AuthHandlerInstance.getUserID()
        let tableData1 = []
        let searchData = {
            searchTerm: this.state.searchTerm,
            searchFor: this.state.searchFor,
        }
        await this.props.GetPurchaseOrderAllocation(searchData)
        if (this.props.poDetails && this.props.poDetails.ProjectAllocationsDetails && this.props.poDetails.ProjectAllocationsDetails.recordset) {
            tableData1 = await this.props.poDetails.ProjectAllocationsDetails.recordset
        }
        await this.setState({ tableData1 })
    }
    getFilterList = async () => {
        await this.props.GetFilterList()
        let TPMList = []
        let CPMList = []
        await this.props.filterList[7].map(async (item) => {
            await TPMList.push({ label: `${item.EmployeeName}`, value: item.UserId })
        })
        await this.props.filterList[10].map(async (item) => {
            await CPMList.push({ label: `${item.EmployeeName}`, value: item.UserId })
        })
        await this.setState({ TPMList, CPMList })
    }
    handleSelectTPM = async (e) => {
        let sortByEmployees = [...this.state.sortByEmployees]
        let SelectedTPM = []
        if (e.length > 0) {
            e.map((item) => {
                sortByEmployees.push(item.value)
                SelectedTPM.push(item)
            })
        }
        await this.setState({ sortByEmployees, SelectedTPM })
        console.log(this.state.sortByEmployees, "tabledataExp1")
    }
    handleSelectCPM = async (e) => {
        let sortByEmployees = [...this.state.sortByEmployees]
        let SelectedCPM = []
        if (e.length > 0) {
            e.map((item) => {
                sortByEmployees.push(item.value)
                SelectedCPM.push(item)
            })
        }
        await this.setState({ sortByEmployees, SelectedCPM })
        console.log(this.state.sortByCPM, "tabledataExp1")
    }
    onSaveAction = async () => {
        let employee = [...this.state.sortByEmployees]
        await employee.map(async (item) => {
            let input = {
                UserId: item,
                ProjectNo: this.state.projectNo,
                ActedUserId: AuthHandlerInstance.getUserID(),
                ActedName: AuthHandlerInstance.getUserPayLoad().fullName,
            }
            await this.props.PurchaseOrderAllocationDetails(input)
        })
        await toast.success('Data has been set.', { duration: 3000 });
        await this.setState({ sortByEmployees: [], SelectedCPM: [], SelectedTPM: [], projectNo: "" })
        await this.DataSync()
    }
    hanleProjectNo = async (e) => {
        let selectedProjectNo = e.target.value
        await this.setState({ projectNo: selectedProjectNo })
    }
    onDelete = async (id) => {
        let input = {
            UserId: 0,
            ProjectNo: this.state.projectNo,
            ActedUserId: AuthHandlerInstance.getUserID(),
            id: id
        }
        await this.props.PurchaseOrderAllocationDetails(input)
        await this.DataSync()
        await toast.success('Data has been Deleted.', { duration: 3000 });

    }
    clearFilter = async () => {
        await this.setState({
            searchTerm: '',
            searchFor: '',
            searchForItem:[]
        })
        await this.DataSync()
    }
     // ? handle search input
     handleISearch = (e) => {
        let searchTerm = e.target.value
        this.setState({searchTerm})
    }
    // ? handle searching
    handleSearching = async () => {
        await this.DataSync()
    }
    handleSelectSearchFor = async (value) => {
        let searchFor = value
        let searchForItem = [{label: value, value: value}]
        await this.setState({ searchFor, searchForItem })
    }
    render() {
        var roles = authInstance.getRoles()
        console.log(this.state.TPMList, "IIIOIOIOIOIOIO")
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }
        const PMAllocationAssignment = () => {
            return [
                {
                    title: 'Project No.',
                    render: rowData => {
                        return <span>{rowData.ProjectCode}</span>;
                    },
                },
                {
                    title: 'Emplpoyee Name',
                    render: rowData => {
                        return <span>{rowData.EmployeeName}</span>;
                    },
                },
                {
                    title: 'Roll Name',
                    render: rowData => {
                        return <span>{rowData.RoleName}</span>;
                    },
                },
                {
                    title: 'Created By',
                    render: rowData => {
                        return <span>{rowData.CreatedBy}</span>;
                    },
                },
                {
                    title: 'Action',
                    render: rowData => {
                        return (
                            <>
                                {rowData.ActedUserId == AuthHandlerInstance.getUserID() ?
                                    <div style={{ textAlign: "center" }}>
                                        <FontAwesomeIcon className="ml-6" icon="trash-alt" color="red" onClick={() => this.onDelete(rowData.ProjectAllocationId)} cursor="pointer" title="Delete" />
                                    </div>
                                    :
                                    <div style={{ textAlign: "center" }}>
                                        <FontAwesomeIcon className="ml-6" icon="trash-alt" color="grey" title="Not Allowed to Delete" />
                                    </div>
                                }
                            </>
                        )
                    },
                },
            ];
        };
        return (

            <div className="Container-fluid p-4 pageheight">
                <div className="row pt-2 pr-4">
                    <div className="col-7">
                        <b>Project Resource Assignment</b>
                    </div>

                    <div className="col-5">
                        <div className="from-group " >
                            <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" clearFilter={this.clearFilter} clear={true} btnName="" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} />
                        </div>
                    </div>
                </div>
                {
                    roles[12] || roles[19] ?
                        <div className="row justify-content-between pb-3 pt-3 m-0 filter-data pr-2 pl-2">
                            <div className="col">
                                <input className="form-control" placeholder="Enter Project Number" type="text" value={this.state.projectNo} onChange={(e) => this.hanleProjectNo(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Project Managers" isMulti value={this.state.SelectedTPM} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.TPMList} onChange={(e) => this.handleSelectTPM(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Commercial Project Managers" isMulti value={this.state.SelectedCPM} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.CPMList} onChange={(e) => this.handleSelectCPM(e)} />
                            </div>
                            <div className="col">
                                <button className="btn2 btn-sms1 float-right rounded-pill" type="submit" onClick={() => this.onSaveAction()}> Save </button>
                            </div>
                        </div>
                        : null
                }
                <div className="row mt-2 sticky">
                    <div className="col-md-12 centre-alligned  wrap">
                        <TableComp cols={PMAllocationAssignment()} data={this.state.tableData1} />
                    </div>
                </div>
            </div>

        )
    }
}



const mapStateToProps = (state) => ({ poDetails: state.poDetails, filterList: state.masterReducer.filterList })
export default connect(mapStateToProps, { GetPOAndPOLineItemSummary, GetFilterList, PurchaseOrderAllocationDetails, GetPurchaseOrderAllocation })(PurchaseOrderAllocation)
